import {otsBaseApi} from "../../ots-api";
import {
    AllocatableLoadInventorySnapshot,
    AllocatableLoadInventorySnapshotEntity
} from "../../../model/allocatable-load-inventory-snapshot";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["AllocatableLoadInventory"]});

export const allocatableLoadInventoryApi = taggedBaseApi.injectEndpoints({
    endpoints: (builder) => ({
        searchAllocatableLoadInventory: builder.query<AllocatableLoadInventorySnapshot[], AllocatableLoadInventorySnapshotEntity>({
            query: (arg) => ({
                url: `/inventory/allocatable-load/search`,
                method: "POST",
                body: arg
            }),
            providesTags: (result, _error, arg, _meta) => {
                return [{type: "AllocatableLoadInventory", id: "LIST"}];
            },
        }),
    })
});

export const {
    useSearchAllocatableLoadInventoryQuery,
} = allocatableLoadInventoryApi;
